import { PropsWithChildren } from "react";
import { FieldErrors } from "react-hook-form";

export interface IMessagesDisplayContainer extends PropsWithChildren {
  marginInlineStart?: string;
  serverMessages?: string[];
  formMessages?: FieldErrors;
  type?: IMessagesType;
}

export enum IMessagesTypeEnum {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

export type IMessagesType = `${IMessagesTypeEnum}`;
